import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const assignDeskUser = createAsyncThunk("assignDeskUser", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`desk/ticket/assign/user?id=${id}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const DeskUserAssignSlice = createSlice({
	name: "DeskUserAssignSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(assignDeskUser.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(assignDeskUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(assignDeskUser.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DeskUserAssignSlice.reducer;
